import JsonApiResource from './JsonApiResource'

export default class AnearApp extends JsonApiResource {

  get shortName() {
    return this.attributes['short-name']
  }

  get longName() {
    return this.attributes['long-name']
  }

  get description() {
    return this.attributes.description
  }

  get iconUrl() {
    return this.attributes['icon-url']
  }

  get flags() {
    return this.attributes.flags
  }

  get canPlayAgain() {
    return this.flags.includes('play_again')
  }

  get openHouse() {
    // Check convenience attribute first, then fallback to flags array
    return this.attributes['open-house'] === true ||
           this.attributes.open_house === true ||
           this.flags.includes('open_house') ||
           this.flags.includes('open-house')
  }
}
